module.exports = __webpack_public_path__ + "static/media/orquestra_salao_4.d2bb8b74.jpg";